import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddPortPayload {
	hardwareResourceId: number; //This comes from Hardware ep
	portName: string;
	portNumber: string;
	portType: string;
	portStatus: string;
	l2Description: string;
	l3Description: string;
	id?: number;
	portId?: string;
}

//GET v1/port/:hardwareId/listPorts
export function getPortsByHardwareId(token: string, hardwareId: string) {
	return axios.get(`${API_URL}/v1/port/${hardwareId}/listports`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
//GET v1/port/hardware/:hardwareId/ports
//This one is for a Select
export function getListPortsByHardwareId(token: string, hardwareId: number) {
	return axios.get(`${API_URL}/v1/port/hardware/${hardwareId}/ports`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
//GET v1/port/id
export function getPortsById(token: string, id: number) {
	return axios.get(`${API_URL}/v1/port/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
//GET v1/port 
//This function returns all ports by default
export function getAllPorts(token: string){
	return axios.get(`${API_URL}/v1/port`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET v1/hardwareResources/listByDatacenter/:datacenterId
export function getHardwareListByDataCenter(
	token: string,
	datacenterId: string
) {

	const encodedId = encodeURIComponent(datacenterId);
	return axios.get(
		`${API_URL}/v1/hardwareResources/listByDatacenter/${encodedId}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);
}

//POST v1/port/add
export function addPort(token: string, payload: AddPortPayload) {
	return axios.post(`${API_URL}/v1/port/add`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/port/:id
export function updatePort(token: string, id: number, payload: AddPortPayload) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/port/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/port/:id
export function deletePort(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/port/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
